import FingerprintJS from "@fingerprintjs/fingerprintjs";

import { getLocalStorageValue, setLocalStorageValue } from "../common/helpers/localStorageHelper";

let fpPromise: Promise<any> | null = null;

export const FINGERPRINT_KEY = "device_fingerprint";

const generateSecureRandomString = (length: number): string => {
	const array = new Uint8Array(length);

	crypto.getRandomValues(array);

	return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join("");
};

export const initializeFingerprint = async (): Promise<string> => {
	try {
		if (fpPromise === null || typeof fpPromise === "undefined") {
			fpPromise = FingerprintJS.load();
		}

		const fp = await fpPromise;
		const result = await fp.get();

		return result.visitorId;
	} catch (error) {
		console.error("Failed to generate device fingerprint:", error);

		const randomPart = generateSecureRandomString(8);

		return `fallback-${Date.now()}-${randomPart}`;
	}
};

export const getStoredFingerprint = (): string | null => {
	return getLocalStorageValue<string | null>(FINGERPRINT_KEY, null);
};

export const storeFingerprint = (fingerprint: string): void => {
	setLocalStorageValue(FINGERPRINT_KEY, fingerprint);
};

export const getOrCreateFingerprint = async (): Promise<string> => {
	const stored = getStoredFingerprint();

	if (stored) {
		return stored;
	}

	const fingerprint = await initializeFingerprint();

	storeFingerprint(fingerprint);

	return fingerprint;
};
